import React from "react";

export function UnreadCount(props: UnreadCountProps) {
    const { unreadCount } = props;

    return unreadCount ? (
        <div
            className={"unread_count"}
            style={{
                top: props.top,
                right: props.right,
                bottom: props.bottom,
                left: props.left
            }}
        >
            {unreadCount > 99 ? 99 : unreadCount}
        </div>
    ) : <></>;
}

type UnreadCountProps = {
    unreadCount: number | undefined | null,
    top?: string,
    right?: string,
    bottom?: string,
    left?: string
}
